/* eslint-disable @angular-eslint/directive-selector */
import {
  Directive,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { MediaQueryService } from 'app/services';

@Directive({
  standalone: false,
  selector: '[amIfTablet]'
})
export class IfTabletDirective {
  constructor(
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private _mediaQueryService: MediaQueryService,
  ) {
    if (_mediaQueryService.isTablet.matches) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    }
  }
}
